document.addEventListener('DOMContentLoaded', function (dom) {
    const pricing = dom.target.querySelector('.js-pricing')
    if (pricing) {
        const th = pricing.querySelectorAll('th');
        if (th.length) {
            th.forEach((e, i) => {
                const labelText = e.textContent + ' : ';
                const td = pricing.querySelectorAll('td:nth-child(' + (i + 1) + ')');
                if (td.length) {
                    td.forEach((e) => {
                        e.setAttribute('data-label', labelText)
                    })
                }
            })
        }
    }
})
